<template>
    <!--Edit Mode START-->
    <div v-if="isModalShown">
        <div class="modal-mask" role="dialog">
            <div class="overlay-mask">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content modal-edit-bg">
                        <div class="modal-body">
                            <div v-if="isFormLoading" class="row">
                                <page-loader></page-loader>
                            </div>
                            <div v-else>
                                <div class="close_btn" v-on:click="CloseModal()"></div>
                                <br>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                                            <div class="my-account-title">Eye Doctor Information</div>
                                            <br>
                                            <span class="account_section_box" v-for="(doctor, index) in AccountEdit.eyeDoctors" :key="index">
                                                <div v-if="index == doctorIndex">
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label"></label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="form-group">
                                                                <label>NPI Number
                                                                    <span v-if="!doctor.useLicenseNumber">*</span>
                                                                    <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                                <i class="fa fa-question-circle-o"></i>
                                                            </span>
                                                                </label>
                                                                <input type="text" maxlength="10" v-on:keypress="G_NumberCheck(this.event)" v-on:keyup="ValidateNpiNumberEyeDoctor(index)" v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorNpiNumber }" v-model="doctor.npiNumber" class="form-control input_field">
                                                                <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorNpiNumber">{{EyeDoctorValidation.EyeDoctorNpiNumber}}</p>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-check">
                                                                        <input value="" v-model="doctor.useLicenseNumber" type="checkbox" class="form-check-input" v-on:change="useLicenseNumberChange(index, doctor.useLicenseNumber)">
                                                                        <label>Use License Number</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label>Relationship*
                                                                    <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                                        <i class="fa fa-question-circle-o"></i>
                                                                    </span>
                                                                </label>
                                                                <select v-bind:class="{ error_field: EyeDoctorValidation.Role }"  v-model="doctor.role" class="form-control">
                                                                    <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                                                                    <option>Self</option>
                                                                    <option>Employee</option>
                                                                    <option>Contractor</option>
                                                                    <option>Unaffiliated</option>
                                                                    <option>Other</option>
                                                                </select>
                                                                <!-- <input type="text" maxlength="10" v-model="Account.Role" v-bind:class="{ error_field: EyeDoctorValidation.Role }" class="form-control"> -->
                                                                <p class="error-message" v-if="EyeDoctorValidation.Role">{{EyeDoctorValidation.Role}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label">Doctor's Name: </label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-group">
                                                                        <label>First Name*</label>
                                                                        <input v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorFirstName }" v-model="doctor.firstName" type="text" class="form-control input_field capitalize">
                                                                        <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorFirstName">{{EyeDoctorValidation.EyeDoctorFirstName}}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-group">
                                                                        <label>Last Name*</label>
                                                                        <input v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorLastName }" v-model="doctor.lastName" type="text" class="form-control input_field capitalize">
                                                                        <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorLastName">{{EyeDoctorValidation.EyeDoctorLastName}}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-group">
                                                                        <label>Suffix*</label>
                                                                        <select v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorSuffix }" v-model="doctor.suffix" class="form-control select_field">
                                                                            <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                                                                        </select>
                                                                        <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorSuffix">{{EyeDoctorValidation.EyeDoctorSuffix}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row" v-if="doctor.useLicenseNumber">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label">License Number/State:</label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="row">
                                                                <div v-if="!doctor.useLicenseNumber" class="clearfix"></div>
                                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-group">
                                                                        <label>License Number *</label>
                                                                        <input maxlength="18" v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorLicenseNumber }" v-model="doctor.licenseNumber" type="text" class="form-control input_field">
                                                                        <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorLicenseNumber">{{EyeDoctorValidation.EyeDoctorLicenseNumber}}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="form-group">
                                                                        <label>State *</label>
                                                                        <select v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorState }" v-model="doctor.state" class="form-control select_field">
                                                                            <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                                                        </select>
                                                                        <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorState">{{EyeDoctorValidation.EyeDoctorState}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label"></label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="form-group">
                                                                <label>Year Licensed</label>
                                                                <div class="row">
                                                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                                        <input v-on:keypress="G_NumberCheck(this.event)" v-on:keyup="G_NumberOfYearsCheck(doctor, 'yearsInPractice')" v-model="doctor.yearsInPractice" class="form-control input_field" v-on:blur="CheckYearLicense(doctor.yearsInPractice)">
                                                                        <!-- REAL TIME VALIDATION -->
                                                                        <p v-if="errorMessage.year" class="error-message">{{errorMessage.year}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label"></label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="form-group">
                                                                <label>Doctor's Email Address*</label>
                                                                <input v-bind:class="{ error_field: EyeDoctorValidation.EyeDoctorEmailAddress }" v-model="doctor.emailAddress" type="text" class="form-control input_field" oninput="this.value = this.value.toLowerCase()">
                                                                <p class="error-message" v-if="EyeDoctorValidation.EyeDoctorEmailAddress">{{EyeDoctorValidation.EyeDoctorEmailAddress}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                            <label class="account_label">Professional Associations:</label>
                                                        </div>
                                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                            <div class="form-group">
                                                                <div v-for="(value, key) in CheckboxIndividual" class="form-check">
                                                                    <p class="form-check-label" v-if="doctor.organizations">
                                                                        <input :value="key" v-model="doctor.organizations.list" class="form-check-input" type="checkbox"> {{key}}
                                                                    </p>
                                                                </div>
                                                                <div class="form-group" v-if="doctor.organizations.list.indexOf('Other') >= 0">
                                                                    <p>Please enter any other professional organizations you are associated with separated by semicolon(;).</p>
                                                                    <input type="text" v-model="doctor.organizations.others" class="form-control input_field">
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </span>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                                <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" type="button" v-on:click="SaveChanges()">Save</button>
                                                <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" type="button" v-on:click="CloseModal()">Cancel</button>
                                            </div>
                                        </div>

                                        <div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Edit Mode START-->
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [
    "AccountView",
    "AccountEdit",
    "FormInputs",
    "Suffix",
    "State",
    'CheckboxIndividual',
    'isFormLoading',
    'eyeDoctorActive',
    'eyeDoctorActiveIndex',
    'EyeDoctorValidation'
  ],
  components: {PageLoader},
  data() {
    return {
        isValid: true,
        isModalShown: true,
        doctorIndex: this.AccountEdit.eyeDoctorActiveIndex,
        errorMessage: {
            year: null
        }
    }
  },
  methods: {
      useLicenseNumberChange(index, value){
          if(value == false){
              this.ValidateNpiNumberEyeDoctor(index);
          } else {
            this.isValid = true;
            this.EyeDoctorValidation.EyeDoctorNpiNumber = null
          }
      },

    AddDoctor() {
      this.AccountEdit.eyeDoctors.push({ useLicenseNumber: false });
      this.EyeDoctorValidation.push({ validationResult: {} });
    },
    RemoveDoctor() {
      this.AccountEdit.eyeDoctors.pop();
    },
    ValidateNpiNumberEyeDoctor(index) {
        if(this.AccountEdit.eyeDoctors[this.doctorIndex].useLicenseNumber == false){
            let npiLength = this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber.length || 0
            if(npiLength != 10){
                this.EyeDoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number"
                this.isValid = false;
            } else {
                this.isValid = true;
            }


        } else {
            this.isValid = true;
            this.EyeDoctorValidation.EyeDoctorNpiNumber = null
        }

        this.$emit("npiIsDirty");
    },
    CloseModal() {
      this.isModalShown = false;
      this.$emit("modalClick");
      document.body.classList.remove("body-overflow");
    },
    SaveChanges(){
        let npiLength = 0
        if(this.AccountEdit.eyeDoctors[this.doctorIndex].useLicenseNumber == false){
            if(this.AccountEdit.eyeDoctors[this.doctorIndex] && this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber){
                npiLength = this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber.length
            }
            if(npiLength != 10){
                this.EyeDoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number"
                this.isValid = false;
            }
            if(this.EyeDoctorValidation.EyeDoctorNpiNumber == null || this.EyeDoctorValidation.EyeDoctorNpiNumber == undefined){
                this.isValid = true;
            } else {
                this.isValid = false;
            }
        }

        if(this.isValid == true){
            this.$emit("saveDoctorChanges");
        } else {
            alert("Please make sure all required fields are complete.")
        }
    },
    NumberOfYearsCheck(input){
        if (input < 1)
        this.AccountEdit.eyeDoctors[this.doctorIndex].yearsInPractice = null;
        else
        this.AccountEdit.eyeDoctors[this.doctorIndex].yearsInPractice  = input;
    },
    CheckYearLicense(yearPractice) {
        var year = yearPractice;
        var result = this.G_CheckYearLicense(year);
        if(result)
            this.errorMessage.year = result;
        else 
            this.errorMessage.year = "";
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditEyeDoctorInfo.vue?aa98badc